
import { FiArrowRight } from "react-icons/fi";

export function CTASection() {
  return (
    <section className="cta-final">
        <h2>Start creating beautiful documents today</h2>
        <p>Join 100+ researchers and students who trust CoffeeLaTek.</p>
        <a href="/signup" className="button">Get Started Free <FiArrowRight /></a>
    </section>
  );
}
